<script lang="ts">
const router = useRouter();
const { $i18n } = useNuxtApp();

export default {
  name: "NavigationDrawer",
  emits: ["changeLocale"],
  props: {
    username: {
      type: String,
    },
  },
  data() {
    return {
      drawer: false,
    };
  },
  methods: {
    async logOut() {
      await useUser().logout();
    },
    toggleDisplayRegistrations() {
      useProspect().displayRegistrations();
      this.drawer = false;
      // If not on page index, redirect to display the Registration section
      if (!router.currentRoute.value.name?.toString().startsWith("index")) {
        navigateTo(useLocalePath()("/") + "/");
      }
    },
  },
};
</script>

<template>
  <v-navigation-drawer
    v-model="drawer"
    location="right"
    temporary
    :touchless="true"
  >
    <template v-if="username">
      <v-list-item class="text-center" :title="username"></v-list-item>

      <v-divider></v-divider>

      <v-list density="compact" nav>
        <v-list-item
          prepend-icon="mdi-account-group"
          :title="$t('header.btnRegistrations')"
          :active="false"
          value=""
          @click="toggleDisplayRegistrations"
        ></v-list-item>
      </v-list>
    </template>

    <v-divider></v-divider>

    <div
      class="text-center align-items-center justify-content-center justify-space-around mt-2"
    >
      <div v-for="locale in $i18n.locales" :key="locale.code" class="mr-2">
        <v-btn
          variant="text"
          :outlined="locale.code !== $i18n.locale"
          :color="locale.code === $i18n.locale ? '#E05C91' : ''"
          @click="$emit('changeLocale', locale.code)"
        >
          {{ locale.code }}
        </v-btn>
      </div>
    </div>

    <!-- Logout button -->
    <template v-slot:append>
      <div class="pa-2">
        <v-btn
          v-if="username"
          block
          class="btn-cim"
          variant="text"
          @click="logOut()"
        >
          {{ $t("header.btnLogout") }}
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>

  <div class="">
    <v-btn size="40" @click.stop="drawer = !drawer" variant="plain"
      ><v-icon size="x-large">mdi-dots-vertical</v-icon></v-btn
    >
  </div>
</template>

<style scoped lang="scss"></style>
